module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "show"
    }
  }, [_c('header', {
    staticClass: "main-header",
    class: {
      contrasted: _vm.isPageContrasted, orange: _vm.isDecember
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left-container"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeModal($event)
      }
    }
  }, [(_vm.isHomePage) ? _c('img', {
    class: {
      'logo-wide': _vm.isDecember
    },
    attrs: {
      "src": _vm.logoSrc,
      "alt": "logo",
      "data-scroll-offset": "0"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }) : _c('img', {
    class: {
      'logo-wide': _vm.isDecember
    },
    attrs: {
      "src": _vm.logoSrc,
      "alt": "logo"
    }
  }), _vm._v(" "), (!_vm.isDecember) ? _c('div', {
    staticClass: "subtitle",
    class: {
      'hidden': _vm.route === 'home'
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/static/img/subtitle.svg",
      "alt": "logo"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isBlogPage) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("blog")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [(_vm.lang === 'pl') ? _c('img', {
    staticClass: "header-logos",
    attrs: {
      "src": "/static/img/logo-header-pl.png",
      "alt": "FE"
    }
  }) : _c('img', {
    staticClass: "header-logos",
    attrs: {
      "src": "/static/img/logo-header.png",
      "alt": "FE"
    }
  })])], 1), _vm._v(" "), (_vm.isAccessibilityVisible) ? _c('div', {
    staticClass: "size-icon",
    on: {
      "click": _vm.sizeToggle
    }
  }, [(!_vm.isPageContrasted) ? _c('img', {
    attrs: {
      "src": "/static/img/zoom-in-icon.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageContrasted) ? _c('img', {
    attrs: {
      "src": "/static/img/zoom-in-icon-yellow.svg"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAccessibilityVisible) ? _c('div', {
    staticClass: "eye-icon",
    on: {
      "click": _vm.contrastToggle
    }
  }, [(!_vm.isPageContrasted) ? _c('img', {
    attrs: {
      "src": "/static/img/eye-icon.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageContrasted) ? _c('img', {
    attrs: {
      "src": "/static/img/eye-icon-yellow.svg"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "burger",
    class: {
      close: _vm.isMenuOpen
    },
    on: {
      "click": _vm.menuToggle
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52186acf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 295
// module chunks = 0